import styled, { StyledComponent } from '@se-admin/falcon';

export const LineThrough: StyledComponent<'span', {}, {}> = styled('span')({
  textDecoration: 'line-through',
});
LineThrough.displayName = 'LineThrough';
